export enum FeatureFlags {
  Integrations = 'ground-robotics-integrations',
  DockProvisioning = 'robotics-dock-provisioning',
  CaptureAgentProvisioning = 'robotics-capture-agent-provisioning',
  DockSerialOverride = 'robotics-dock-serial-override',
  CommandPalette = 'robotics-command-palette',
  ProfileFileSync = 'robotics-profile-level-file-sync',
  DashboardWebComponentEditor = 'robotics-dashboard-web-component-editor',
  AutomateNewUploader = 'robotics-automate-new-uploader',
  AutomateImportExport = 'robotics-automate-import-export',
  ProjectOverview = 'robotics-project-overview-component',
  ProfileFlows = 'robotics-profile-level-flows',
  VirtualRobots = 'robotics-virtual-robots',
  StorageStreamWidgets = 'robotics-storage-stream-widgets',
  CloudFlows = 'robotics-cloud-flows',
  OperationMissionsPanel = 'robotics-operation-mission-panel',
  ButtonRunJs = 'robotics-button-run-js',
  OperationPageJSWidgets = 'robotics-operation-page-js-widgets',
  Automate = 'robotics-automate',
  Controls = 'robotics-controls',
  Maps = 'robotics-maps',
  NewStatusIndicator = 'robotics-eh-new-status-indicator',
  HitlFeatures = 'robotics-hitl-features',
}

export const defaultFeatureFlags: Record<FeatureFlags, boolean> = {
  [FeatureFlags.Integrations]: false,
  [FeatureFlags.DockProvisioning]: false,
  [FeatureFlags.CaptureAgentProvisioning]: false,
  [FeatureFlags.DockSerialOverride]: false,
  [FeatureFlags.CommandPalette]: false,
  [FeatureFlags.ProfileFileSync]: false,
  [FeatureFlags.AutomateNewUploader]: false,
  [FeatureFlags.DashboardWebComponentEditor]: false,
  [FeatureFlags.AutomateImportExport]: false,
  [FeatureFlags.ProjectOverview]: false,
  [FeatureFlags.ProfileFlows]: false,
  [FeatureFlags.VirtualRobots]: false,
  [FeatureFlags.StorageStreamWidgets]: false,
  [FeatureFlags.CloudFlows]: false,
  [FeatureFlags.OperationMissionsPanel]: false,
  [FeatureFlags.ButtonRunJs]: false,
  [FeatureFlags.OperationPageJSWidgets]: false,
  [FeatureFlags.Automate]: false,
  [FeatureFlags.Controls]: false,
  [FeatureFlags.Maps]: false,
  [FeatureFlags.NewStatusIndicator]: false,
  [FeatureFlags.HitlFeatures]: false,
};
